import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";

import { EditIcon, CheckIcon, UndoIcon } from "./icons";

export const EditButtons = (props) => {
  const { editMode, disabled, handleEdit, handleUndo, handleCommit, invalid } = props || {};
  const [state, setState] = useState({ editMode: editMode });

  const onEdit = React.useCallback(() => {
    setState({ editMode: true });
    if (typeof handleEdit === "function") handleEdit();
  }, [handleEdit]);

  const onUndo = React.useCallback(() => {
    setState({ editMode: false });
    if (typeof handleUndo === "function") handleUndo();
  }, [handleUndo]);

  const onCommit = React.useCallback(() => {
    setState({ editMode: false });
    if (typeof handleCommit === "function") handleCommit();
  }, [handleCommit]);

  if (!state.editMode) {
    return <Button
      variant="link"
      className="input-group-text p-0"
      disabled={disabled}
      onClick={onEdit}
    >
      <EditIcon /><span className="visually-hidden">Editieren</span>
    </Button>;
  } else {
    return <Form.Group>
      <Button
        variant="default"
        className="input-group-text pt-0 pb-0"
        onClick={onUndo}
      >
        <UndoIcon /><span className="visually-hidden">Abbrechen</span>
      </Button>
      <Button
        variant="info"
        className="input-group-text pt-0 pb-0"
        onClick={onCommit}
        disabled={invalid}
      >
        <CheckIcon /><span className="visually-hidden">Senden</span>
      </Button>
    </Form.Group>;
  }
};
